function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m103.09 108.59 1.41 1.41 5-5-5-5-1.41 1.41 2.58 2.59H96v2h9.67ZM112 96H98a2 2 0 0 0-2 2v4h2v-4h14v14H98v-4h-2v4a2 2 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V98a2.006 2.006 0 0 0-2-2Z",
    transform: "translate(-96 -96)",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgExit;